module.exports = __webpack_public_path__ + "img/logoAqua.7e0cc018.png";